/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Bar_Processing_OneInputs */



/**
* | output |
* | --- |
* | "{count} item processing..." |
*
* @param {Activity_Bar_Processing_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_bar_processing_one = /** @type {((inputs: Activity_Bar_Processing_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Bar_Processing_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Element wird verarbeitet...`)
	return /** @type {LocalizedString} */ (`${i?.count} item processing...`)
});